export const constants = {
  MFE_FACTORY_GPT_NAME: 'factoryGpt',
  MFE_EXPOSED_PATH: './FactoryGptApp',
  WIDGET_EXPOSED_PATH: './FactoryGptWidget',
};
